import * as THREE from 'three';
import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment.js';

/** ピクセル比クランプ(端末発熱・電池対策、計画書§11) */
const MAX_PIXEL_RATIO = 2;

/** Three.js WebGLRenderer の共通設定 */
export function createRenderer(container: HTMLElement): {
  renderer: THREE.WebGLRenderer;
  scene: THREE.Scene;
  camera: THREE.PerspectiveCamera;
} {
  const renderer = new THREE.WebGLRenderer({
    antialias: true,
    alpha: true, // パスBでカメラ映像<video>を背景に透過表示するため必須
    powerPreference: 'default',
  });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, MAX_PIXEL_RATIO));
  renderer.setSize(window.innerWidth, window.innerHeight);
  renderer.setClearColor(0x000000, 0); // 透明背景
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.xr.enabled = true;
  renderer.domElement.id = 'ar-canvas';
  container.appendChild(renderer.domElement);

  const scene = new THREE.Scene();

  // 金属マテリアル(ジュラルミン外板・弾殻破片)の反射に環境マップが必要
  // (envMapなしのmetalness>0はほぼ黒に沈む)。軽量な生成環境を一度だけ焼く
  const pmrem = new THREE.PMREMGenerator(renderer);
  scene.environment = pmrem.fromScene(new RoomEnvironment(), 0.04).texture;
  scene.environmentIntensity = 1.1;
  pmrem.dispose();
  // far=24000: ジオフェンス半径10km内のどこからでも、約11km先から進入するB-29を描画するため
  const camera = new THREE.PerspectiveCamera(70, window.innerWidth / window.innerHeight, 0.1, 24000);

  // 屋外想定のシンプルなライティング
  scene.add(new THREE.HemisphereLight(0xffffff, 0x60594c, 2.4));
  const sun = new THREE.DirectionalLight(0xffffff, 1.6);
  sun.position.set(50, 120, -40);
  scene.add(sun);

  window.addEventListener('resize', () => {
    if (renderer.xr.isPresenting) return;
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
  });

  return { renderer, scene, camera };
}
